// extracted by mini-css-extract-plugin
export default {"subTilte":"SubTilte_subTilte__S81dp","h2":"SubTilte_h2__PVfv0"};